import { useState } from "react";

const navItems = [
  { label: "头条深挖", href: "#feed" },
  { label: "话题墙", href: "#topics" },
  { label: "资本·金主", href: "#backers" },
  { label: "关系网", href: "#relations" },
  { label: "私下聊天", href: "#chats" },
  { label: "深挖档案", href: "#archive" },
  { label: "读者热议", href: "#comments" },
];

export default function TopNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-page items-center gap-4 px-4 md:px-6">
        <a
          href="#top"
          className="flex shrink-0 items-center gap-2 py-3"
          aria-label="呱呱爆料 首页"
        >
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-500 text-sm font-black text-background-50">
            呱
          </span>
          <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
            呱呱爆料
          </span>
        </a>

        <nav className="ml-auto hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-3 lg:ml-0">
          <span className="hidden items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900 sm:flex">
            <span className="relative flex h-1.5 w-1.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75" />
              <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-accent-600" />
            </span>
            3 条正在深挖
          </span>
          <a
            href="#cta"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            提供线索
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            aria-expanded={open}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-lg text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200/70 bg-background-50 px-4 py-2 lg:hidden">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              className="block border-b border-background-100 py-3 text-sm text-foreground-800 last:border-0"
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}